import { render, staticRenderFns } from "./RepositoryGrid.vue?vue&type=template&id=0b520cdc&"
import script from "./RepositoryGrid.ts?vue&type=script&lang=js&"
export * from "./RepositoryGrid.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports